module.exports = __webpack_public_path__ + "static/media/headshot.973ec2dd.jpg";